import { Directive, Output, EventEmitter, ElementRef, Renderer2, OnInit, Input, OnDestroy } from '@angular/core';
import { environment } from '@frontend/unhideschool/env';

@Directive({
  selector: '[unhCustomCropperButton]',
  exportAs: 'unhCustomCropperButton'
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class CustomCropperButton implements OnDestroy {
  @Input() set ready(isready) {
    if (isready) {
      this.handleCustomCircleCropper();
    }
  }

  @Input() type: 'circle' | 'square';

  @Output() dragChange = new EventEmitter();

  constructor(
    private _el: ElementRef,
    private renderer: Renderer2

  ) { }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'set-custom-cropper')
  }

  handleCustomCircleCropper() {
    setTimeout(() => {
      const trigger = this.type == 'square' ? 'topright' : 'top';
      this.renderer.addClass(document.body, 'set-custom-cropper')

      const resizerElementList = (this._el.nativeElement as Element).querySelectorAll("span.ngx-ic-resize");
      resizerElementList.forEach((element) => !element.className.includes(trigger) ? element.remove() : null);
      const cropper = (this._el.nativeElement as Element).querySelector(".ngx-ic-cropper");

      const topRightTrigger = (this._el.nativeElement as Element).querySelector(".ngx-ic-topright");
      if (this.type != 'square') {
        this.handleCircle(topRightTrigger, cropper);
      } else {
        this.handleSquare(topRightTrigger);

      }

      const topLeftTrigger = (this._el.nativeElement as Element).querySelector(".ngx-ic-topleft");
      if(topLeftTrigger){
        topLeftTrigger.remove();
      }
    }, 1);
  }
  handleCircle(topRightTrigger, cropper) {
    const icon = getIconElement(environment.cdnUrl + '/cropper-icons/crop-resize-icon.svg');

    topRightTrigger.firstChild.remove();
    topRightTrigger.appendChild(icon);


    const resizeBarTop = (this._el.nativeElement as Element).querySelector(".ngx-ic-resize-bar.ngx-ic-top");

    resizeBarTop.append(topRightTrigger)
    this.renderer.setStyle(cropper, 'transform', 'rotate(45deg)')
    this.renderer.setStyle(cropper, 'justify-content', 'center')
    this.renderer.setStyle(cropper, 'cursor', 'initial')
    this.renderer.setStyle(resizeBarTop, 'width', 'fit-content')
    this.renderer.setStyle(resizeBarTop, 'top', 'initial')
    this.renderer.setStyle(resizeBarTop, 'left', 'initial')
  }

  handleSquare( topRightTrigger) {
    const icon = getIconElement(environment.cdnUrl + '/cropper-icons/crop-resize-icon.svg');
    topRightTrigger.firstChild.remove();
    topRightTrigger.appendChild(icon);
    this.renderer.setStyle(topRightTrigger.firstChild, 'transform', 'rotate(0)')

  }
}

function getIconElement(url) {
  const element = document.createElement('div');
  element.classList.add('resize-trigger-icon-wrapper')
  element.innerHTML = `
    <unh-icon url="${url}"></unh-icon>
  `
  return element;
}
